import { useState } from 'react';
import CertificazioniService from '../services/CertificazioniService/CertificazioniService';
import { alertService } from '../services/AlertService';
import { handleError } from '../model/handleError';

const useCertificazioni = () => {
  const [loadingState, setLoadingState] = useState({
    isLoadingCertificazioni: false,
    isLoadingCertificazioneCreating: false,
    isLoadingCertificazioneDelete: false,
    isLoadingCertificazioneUpdate: false,
    isLoadingCertificazioniByParams: false,
  });

  const [modalState, setModalState] = useState({
    showModalInfoCertificazione: false,
    showModalCreateCertificazione: false,
    showModalDeleteCertificazione: false,
    showModalUpdateCertificazione: false
  });

  const getAllCertificazioni = async () => {
    setLoadingState({ ...loadingState, isLoadingCertificazioni: true });
    try {
      let response = await CertificazioniService.getAllCertificazioni();
      if (response.ok) {
        const certificazioni = await response.json();
        return certificazioni;
      }
    } catch (error) {
      alertService.error("Si è verificato un errore nel tentativo di visualizzare le certificazioni", {autoClose: true});
    } finally {
      setLoadingState({ ...loadingState, isLoadingCertificazioni: false });
    }
  };

  const getCertificazioniByParams = async (params) => {
    setLoadingState({ ...loadingState, isLoadingCertificazioniByParams: true });
    try {
      let obj;
      let response = await CertificazioniService.getCertificazioniByParams(params);
      const res = await response.json();
      const totalRecord = response.headers.get('X-Total-Record');
      obj = {
        data: res,
        count: totalRecord
      }
      return obj;
    } catch (err) {
      handleError(err);
    } finally {
      setLoadingState({ ...loadingState, isLoadingCertificazioniByParams: false });
    }
  };

  const createCertificazione = async (data) => {
    setLoadingState({ ...loadingState, isLoadingCertificazioneCreating: true });
    try {
      let response = await CertificazioniService.createCertificazione(data);
      alertService.success("Certificazione creata con successo", {autoClose: true});
      setModalState({...modalState, showModalCreateCertificazione: false });
      return response;
    } catch (error) {
      handleError(error);
    } finally {
      setLoadingState({ ...loadingState, isLoadingCertificazioneCreating: false });
    }
  };

  const deleteCertificazione = async (id) => {
    try {
      setLoadingState({ ...loadingState, isLoadingCertificazioneDelete: true });
      let response = await CertificazioniService.deleteCertificazione(id);
      const res = await response.json();
      alertService.success("Certificazione eliminata con successo", {autoClose: true});
      setModalState({...modalState, showModalDeleteCertificazione: false });
      return res;
    } catch (error) {
      handleError(error);
    } finally {
      setLoadingState({ ...loadingState, isLoadingCertificazioneDelete: false });
    }
  };

  const updateCertificazione = async (data) => {
    try {
      setLoadingState({ ...loadingState, isLoadingCertificazioneUpdate: true });
      let response = await CertificazioniService.updateCertificazione(data);
      alertService.success("Certificazione aggiornata con successo", {autoClose: true});
      setModalState({...modalState, showModalUpdateCertificazione: false });
      return response;
    } catch (error) {
      handleError(error);
    } finally {
      setLoadingState({ ...loadingState, isLoadingCertificazioneUpdate: false });
    }
  };

  return {
    getAllCertificazioni,
    createCertificazione,
    loadingStateCertificazioni: loadingState,
    modalStateCertificazioni: modalState,
    setModalStateCertificazioni: setModalState,
    updateCertificazione,
    deleteCertificazione,
    getCertificazioniByParams
  };
}

export default useCertificazioni;

